let env = '${ENV_NAME}';
let apiUrl = '${API_URL}';
let baseUrl = '${BASE_URL}';
let production = '${IS_PROD}';
let sociuuhubApiUrl = '${HUB_URL}';
let sentryDSN = '${SENTRY_FE_DSN}';
let origin = '${ORIGIN}';
let reverbHost = '${REVERB_HOST}';
let reverbPort = Number('${REVERB_PORT}');
let reverbKey = '${REVERB_KEY}';
let reverbScheme = '${REVERB_SCHEME}';
let hubSpotPortalId = '${HUBSPOT_PORTAL_ID}';

export let environment = {
  origin: origin,
  env: env,
  apiUrl: apiUrl,
  baseUrl: baseUrl,
  production: production,
  sociuuhubApiUrl: sociuuhubApiUrl,
  sentryDSN: sentryDSN,
  reverbHost: reverbHost,
  reverbPort: Number.isNaN(reverbPort) ? 6001 : reverbPort,
  reverbKey: reverbKey,
  reverbScheme: reverbScheme,
  hubSpotPortalId: hubSpotPortalId,
};
